import React, { useContext, useEffect, useState } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
  DialogContentText,
  Divider,
  TextField,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "./deletechartofaccount.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { DELETE_CHART_OF_ACCOUNT } from "../../Schema/ChartOfAccount";

export default function DeleteChartOfAccount({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const [chartAccountVal, setChartAccountVal] = useState("");

  const [deleteChartOfAccount] = useMutation(DELETE_CHART_OF_ACCOUNT, {
    onCompleted: ({ deleteChartOfAccount }) => {
      // console.log("deleteChartOfAccount::", deleteChartOfAccount);
      setLoading(false);
      if (deleteChartOfAccount?.status === true) {
        setAlert(true, "success", deleteChartOfAccount?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteChartOfAccount?.message);
      }
    },
    onError: (error) => {
      console.log(error.message);
      setLoading(false);
    },
  });

  const handleDelete = () => {
    // setLoading(true);
    // deleteChartOfAccount({
    //   variables: {
    //     chartAccountId: editData?._id,
    //   },
    // });
    setLoading(true);
    deleteChartOfAccount({
      variables: {
        chartAccountId: editData?._id,
      },
    });
  };

  useEffect(() => {
    setChartAccountVal("");
  }, [open]);

  // console.log("editData", editData);
  return (
    <Dialog
      className="delete-user"
      aria-labelledby="responsive-dialog-title"
      open={open}
    >
      <DialogTitle id="responsive-dialog-title">
        <Stack direction="row">
          <Stack className="header-title"> Delete Chart of Account </Stack>
          <Box sx={{ flexGrow: 1 }}></Box>
          <IconButton>
            <BiMinusCircle onClick={handleClose} className="close-icon" />
          </IconButton>
        </Stack>
        <Divider sx={{ mt: 1 }} />
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <Box className="box-form">
            <Stack direction="row" spacing={1} width="100%">
              <Typography variant="subtitle1">
                Do you want to Delete this data?
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} width="100%" sx={{ mt: 2 }}>
              <Typography variant="subtitle1">Please type</Typography>
              <Typography className="body-void" variant="subtitle1">
                CHART OF ACCOUNT
              </Typography>
              <Typography variant="subtitle1">to delete</Typography>
            </Stack>

            <Stack
              direction="row"
              justifyContent="center"
              spacing={1}
              width="100%"
              sx={{ mb: 3 }}
            >
              <TextField
                size="small"
                fullWidth
                onChange={(e) => setChartAccountVal(e.target.value)}
              />
            </Stack>
            <Grid item container spacing={4}>
              <Grid item xs={12}>
                {chartAccountVal === "CHART OF ACCOUNT" ? (
                  loading ? (
                    <Button
                      sx={{
                        ":hover": { backgroundColor: "red", border: "none" },
                      }}
                      className="btn-delete"
                      variant="outlined"
                      fullWidth
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button
                      sx={{
                        ":hover": { backgroundColor: "red", border: "none" },
                      }}
                      className="btn-delete"
                      variant="outlined"
                      fullWidth
                      onClick={handleDelete}
                    >
                      delete now
                    </Button>
                  )
                ) : (
                  <Button variant="outlined" fullWidth>
                    delete
                  </Button>
                )}
              </Grid>
            </Grid>
          </Box>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
